import Vue from 'vue'
import Router from 'vue-router'
import { getToken } from '@/plugins/auth'
import Home from '@/pages/home/Home'
import List from '@/pages/components/List'
import cloudScene from "@/pages/cloudScene/index"
import materialTest from "@/pages/materialTest/materialTesting"
import highTest from "@/pages/materialTest/highTest"
import materialProcessing from "@/pages/materialTest/materialProcessing"
import lifeSciences from "@/pages/materialTest/lifeSciences"
import environmentDetection from "@/pages/materialTest/environmentDetection"
import analogComputation from "@/pages/materialTest/analogComputation"
import scientificDraw from "@/pages/materialTest/scientificDraw"
import thesisServices from "@/pages/materialTest/thesisServices"
import dataAnalysis from "@/pages/materialTest/dataAnalysis"
import patentServices from "@/pages/materialTest/patentServices"
import bioDetection from "@/pages/materialTest/bioDetection.vue"
import equipmentMall from "@/pages/materialTest/equipmentMall/index.vue"
import equipmentMallDetail from "@/pages/materialTest/equipmentMall/equipmentMallDetail.vue"
import equipDetails from "@/pages/common/equipDetails"
import appointPage from "@/pages/common/appointPage"
import immediatePay from "@/pages/common/immediatePay"
import releaseRequire from "@/pages/common/releaseRequire"
import aboutUsIndex from "@/pages/aboutUs/index"
import aboutUsList from "@/pages/aboutUs/list"
import carouselDetail from "@/pages/components/carouselDetails"
import aliPay from "@/pages/common/Alipay"
import cooperativeSettlement from "@/pages/cooperativeSettlement/index"
import search from "@/pages/search/index"
//活动相关
import preActive from "@/pages/actives/pre"
import newActive from "@/pages/actives/new"
import inviteActive from "@/pages/actives/invite"
//团购活动
import teamShopList from "@/pages/actives/teamShop/teamShopList"
import teamShopDetail from "@/pages/actives/teamShop/teamShopDetail"
//返现活动
import cashBack from "@/pages/actives/cashBack/index"
// 幸运转盘
import wheelPrize from "@/pages/actives/wheelPrize/index"
// 检测抽奖
import checkActivity from "@/pages/actives/checkActivity/index"
// 登录页面
import loginPage from '@/pages/index/login.vue'
//隐私协议
import privacyAgreement from '@/pages/index/privacyAgreement.vue'
// 注册协议
import registrationAgreement from '@/pages/index/registrationAgreement.vue'

Vue.use(Router)

// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
const scrollBehavior = function scrollBehavior(to, from, savedPosition) {
  if (savedPosition) {
    return savedPosition;
  } else {
    return { x: 0, y: 0 }
  }
};
const router = new Router({
  scrollBehavior,
  mode: 'history', // 去掉url中的#
  routes: [{
    path: '/',
    name: 'Home',
    component: Home,
    redirect: '/',
    children: [
      // 首页
      {
        path: '/',
        name: 'list',
        component: List
      },
      // 轮播详情
      {
        path: '/carouselDetail',
        name: 'carouselDetail',
        component: carouselDetail
      },
      // 云现场
      {
        path: '/cloudScene',
        name: 'cloudScene',
        component: cloudScene
      },
      // 材料检测
      {
        path: '/materialTest',
        name: 'materialTest',
        component: materialTest
      },
      //高端测试
      {
        path: 'highTest',
        name: 'highTest',
        component: highTest
      },
      //材料加工
      {
        path: 'materialProcessing',
        name: 'materialProcessing',
        component: materialProcessing
      },
      //生命科学
      {
        path: 'lifeSciences',
        name: 'lifeSciences',
        component: lifeSciences
      },
      //环境检测
      {
        path: 'environmentDetection',
        name: 'environmentDetection',
        component: environmentDetection
      },
      //模拟计算
      {
        path: 'analogComputation',
        name: 'analogComputation',
        component: analogComputation
      },
      //科研绘图
      {
        path: 'scientificDraw',
        name: 'scientificDraw',
        component: scientificDraw
      },
      //论文服务
      {
        path: 'thesisServices',
        name: 'thesisServices',
        component: thesisServices
      },
      //数据分析
      {
        path: 'dataAnalysis',
        name: 'dataAnalysis',
        component: dataAnalysis
      },
      //专利服务
      {
        path: 'patentServices',
        name: 'patentServices',
        component: patentServices
      },
      // 生物检测
      {
        path: '/bioDetection',
        name: 'bioDetection',
        component: bioDetection
      },
      //仪器采购
      {
        path: '/equipmentMall',
        name: 'equipmentMall',
        component: equipmentMall
      },
      //仪器采购---仪器详情
      {
        path: '/equipmentMallDetail',
        name: 'equipmentMallDetail',
        component: equipmentMallDetail
      },
      //设备详情
      {
        path: '/equipDetails',
        name: 'equipDetails',
        component: equipDetails
      },
      //预约
      {
        path: '/appointPage',
        name: 'appointPage',
        component: appointPage
      },
      //待支付
      {
        path: '/immediatePay',
        name: 'immediatePay',
        component: immediatePay
      },
      //发布需求
      {
        path: '/releaseRequire',
        name: 'releaseRequire',
        component: releaseRequire
      },
      //个人中心
      {
        path: '/aboutUsIndex',
        name: 'aboutUsIndex',
        component: aboutUsIndex
      },
      //合作入驻
      {
        path: '/cooperativeSettlement',
        name: 'cooperativeSettlement',
        component: cooperativeSettlement
      },
      //关于我们
      {
        path: '/aboutUsList',
        name: 'aboutUsList',
        component: aboutUsList
      },
      //跳转支付宝中间页面
      {
        path: '/AliPayOrder',
        name: 'AliPayOrder',
        component: aliPay
      },
      //预存活动页面
      {
        path: '/preActive',
        name: 'preActive',
        component: preActive
      },
      //平台上新活动页面
      {
        path: '/newActive',
        name: 'newActive',
        component: newActive
      },
      //邀请好友活动页面
      {
        path: '/inviteActive',
        name: 'inviteActive',
        component: inviteActive
      },
      // 搜索
      {
        path: '/search',
        name: 'search',
        component: search
      },
      //团购活动
      {
        path: '/teamShopList',
        name: 'teamShopList',
        component: teamShopList
      },
      {
        path: '/teamShopDetail',
        name: 'teamShopDetail',
        component: teamShopDetail
      },
      //返现活动
      {
        path: '/cashBack',
        name: 'cashBack',
        component: cashBack
      },
      //幸运转盘
      {
        path: '/wheelPrize',
        name: 'wheelPrize',
        component: wheelPrize
      },
      // 检测抽奖
      {
        path: '/checkActivity',
        name: 'checkActivity',
        component: checkActivity
      }
    ]
  },
  {
    path: '/login',
    name: 'login',
    component: loginPage
  },
  {
    path: '/privacyAgreement',
    name: 'privacyAgreement',
    component: privacyAgreement
  },
  {
    path: '/registrationAgreement',
    name: 'registrationAgreement',
    component: registrationAgreement
  },
  ]
})

router.beforeEach((to, from, next) => {
  const token = getToken()
  // 兼容旧的登录链接，统一进入独立登录页。
  if (to.query.openLogin === '1' && !token) {
    next({
      path: '/login',
      query: {
        redirect: to.path,
        inviterType: to.query.inviterType,
        inviterPhoneNumber: to.query.inviterPhoneNumber
      }
    })
    return
  }
  // 个人中心必须登录访问，并在登录成功后返回原目标页面。
  if (to.path === '/aboutUsIndex' && !token) {
    next({
      path: '/login',
      query: {
        redirect: to.fullPath
      }
    })
    return
  }
  if (to.path === '/login' && token) {
    next(typeof to.query.redirect === 'string' ? to.query.redirect : '/')
    return
  }
  next()
})

export default router
